export default "__VITE_ASSET__CFrvEsBb__"